export default __webpack_public_path__ + "static/media/1-2-hour.ed71b10c.png";